export default __webpack_public_path__ + "static/media/screenshotMonitoring.96a48ad7.png";